<div class="pane-container">
  <app-container-type-overview #overview [sorting]="sorting.field" title="Container Types"
    (selection)="onShortcut($event)"></app-container-type-overview>
  <app-action-pane domain="SETTINGS" [hint]="['Identifier', 'Name']" (action)="onAction($event)"
    (magic)="onSearch({ magic: $event })"></app-action-pane>
</div>
<div *ngIf="creation; then showForm else showList"></div>
<ng-template #showForm>
  <app-container-type-form [creation]="true" [mode]="Mode.edition" [object]="containerType" (event)="onEvent($event)"></app-container-type-form>
</ng-template>
<ng-template #showList>
  <app-container-type-list #list [sorting]="sorting" (event)="onEvent($event)" (page)="onScroll()" (sort)="onSort($event)"></app-container-type-list>
</ng-template>
